export const controlPanelTabNames = {
  expirationTabName: 'expiration_panel',
  pendingSignatureTabName: 'pending_signatures_panel',
};

export const controlPanelTabNameList = Object.values(controlPanelTabNames);
